import {
    GET_CLIENT,
    LOAD_DATA,
    QUESTION_ANSWER,
    QUESTION_VOTE,
    SEND_FORM,
    VOTE,
    FORM_SUCCESS,
    FORM_ERROR
} from '../constants';
import {fromJS, List, Map} from 'immutable';


const initialState = Map({
    open: true,
    sent: false,
    mark: null,
    questions: List(),
    loading: false,
    submit: false,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case VOTE:
            return state.set('mark', action.mark)

        case QUESTION_VOTE:
            return state.setIn(['questions', action.i, 'mark'], action.mark);

        case QUESTION_ANSWER:
            return state.setIn(['questions', action.i, 'answer'], action.answer);

        case SEND_FORM:
            return state
                    .set('submit', true);

        case FORM_SUCCESS:
            return state
                .set('open', false)
                .set('submit', false)
                .set('sent', true);

        case FORM_ERROR:
            return state
                .set('submit', false)
                .set('sent', true);

        case LOAD_DATA:
            return state.set('loading', true);

        case GET_CLIENT:
            let mark = state.get('mark');

            if(mark === null) {
                mark = action.data.mark
            }

            return state
                    .set('questions', fromJS(action.data.questions))
                    .set('open', action.data.open)
                    .set('mark', mark)
                    .set('loading', false);

        default:
            return state
    }
}






// WEBPACK FOOTER //
// ./src/reducers/voter.js